import React from 'react'
import { Footer } from '../../components/Footer'
import { Header } from '../../components/Header'
import HeadMeta from '../../components/HeadMeta'

const CompanyAboutPage = () => {
  return (
    <div>
      <HeadMeta title="会社概要 | 企業情報 | 株式会社ベツダイ" description="マイホームはマイライフ。ベツダイがずっと大切にしているこの想いは、今までも、そしてこれからも変わることはありません。これからの時代と響き合う家づくりへ。私たちのチャレンジは続きます。" />
      <noscript>
        &lt;style&gt;body{'{'}visibility:visible{'}'}&lt;/style&gt;
      </noscript>
      <div className="c-page-sub__base">
        <div className="c-page-sub__header">
          <Header />
        </div>
        <div className="c-page-sub__breadcrumb">
          <div className="c-nav-breadcrumb">
            <ol>
              <li className="c-nav-breadcrumb__item"><a href="/">トップ</a></li>
              <li className="c-nav-breadcrumb__item"><a href="/company/">企業情報</a></li>
              <li className="c-nav-breadcrumb__item" data-breadcrumb="current">会社概要</li>
            </ol>
          </div>
        </div>
        <div className="c-page-sub__main">
          <main>
            <article>
              <div className="c-page-sub__title-page">
                <div className="c-title-page" data-page="default">
                  <h1><span data-lang="en">ABOUT</span><span data-lang="ja">会社概要</span></h1>
                </div>
              </div>
              <div className="c-page-sub__content-main">
                <div className="c-content-main">
                  <section data-type="section" data-mb="small" data-bgcolor="true">
                    <div className="concept-nav">
                      <ul>
                        <li><a href="/company/">企業コンセプト</a></li>
                        <li data-current="true">会社概要</li>
                        <li><a href="/company/office/">事務所・店舗案内</a></li>
                        <li><a href="/company/media/">CM・メディア掲載</a></li>
                      </ul>
                    </div>
                  </section>
                  <section data-type="section">
                    <div data-type="table">
                      <table className="col1-table">
                        <tbody>
                          <tr>
                            <th>会社名</th>
                            <td>株式会社ベツダイ</td>
                          </tr>
                          <tr>
                            <th>役員</th>
                            <td>
                            代表取締役社長　矢邉 弘<br />
                            {/* 取締役 副社長　山崎 茂<br /> */}
                            取締役 専務　中野 康彦<br />
                            {/* 取締役 専務　江田 光成<br /> */}
                            {/* 取締役 常務　姫野 友輔<br /> */}
                            {/* 取締役 東京支社長　林 哲平<br /> */}
                            取締役 常務　灘浪 睦夫<br />
                            取締役　村上 耕次<br />
                            監査役　南 賢吾
                            </td>
                          </tr>
                          <tr>
                            <th>大分office</th>
                            <td>
                              <p>〒870-0904　大分市向原東2丁目2番30号<br />TEL&nbsp;<a href="tel:0975746330">097-574-6330</a> FAX 097-551-6366</p>
                              <p>その他事業所については、<a href="/company/office/">事業所・店舗案内ページ</a>をご覧ください</p>
                            </td>
                          </tr>
                          <tr>
                            <th>創立</th>
                            <td>昭和38年3月7日</td>
                          </tr>
                          <tr>
                            <th>資本金</th>
                            <td>100,000,000円</td>
                          </tr>
                          <tr>
                            <th>従業員数</th>
                            <td>216名</td>
                          </tr>
                          <tr>
                            <th>登録許可</th>
                            <td>
                              <ul>
                                <li>特定建設業　国土交通大臣免許(特-6)第25328号</li>
                                <li>一級建築士事務所/大分県知事登録　第22S-13264</li>
                                <li>宅地建物取引業　国土交通大臣(3)第008565号</li>
                                <li>マンション管理業　国土交通大臣(4)第092959号</li>
                                <li>賃貸住宅管理業者　国土交通大臣(2)第0001295号</li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <th>取引銀行</th>
                            <td>豊和銀行、 大分銀行、 福岡銀行、 西日本シティ銀行、 伊予銀行、 北九州銀行、 大分みらい信用金庫、 宮崎銀行、 三井住友銀行、 みずほ銀行、 肥後銀行、日本政策金融公庫、他</td>
                          </tr>
                          <tr>
                            <th>有資格者<br data-pconly />(令和7年4月1日現在)</th>
                            <td>
                              <dl className="flex">
                                <dt>宅地建物取引士</dt>
                                <dd>34名</dd>
                                <dt>管理業務主任者</dt>
                                <dd>1名</dd>
                                <dt>1級建築士</dt>
                                <dd>4名</dd>
                                <dt>2級建築士</dt>
                                <dd>21名</dd>
                                <dt>1級建築施工管理技士</dt>
                                <dd>6名</dd>
                                <dt>2級建築施工管理技士</dt>
                                <dd>4名</dd>
                                <dt>1級土木施工管理技士</dt>
                                <dd>2名</dd>
                                <dt>2級土木施工管理技士</dt>
                                <dd>1名</dd>
                                <dt>インテリアコーディネーター</dt>
                                <dd>16名</dd>
                                <dt>カラーコーディネーター</dt>
                                <dd>5名</dd>
                                <dt>ファイナンシャルプランナー</dt>
                                <dd>6名</dd>
                                <dt>マンションリフォームマネジャー</dt>
                                <dd>1名</dd>
                              </dl>
                            </td>
                          </tr>
                          <tr>
                            <th>電子公告</th>
                            <td>
                              <dl className="flex">
                              <dt>電子公告は<a href="/ir">こちら</a></dt>
                              </dl>
                            </td>
                          </tr> 
                        </tbody>
                      </table>
                    </div>
                  </section>
                </div>
              </div>
            </article>
          </main>
        </div>
        <div className="c-page-sub__footer">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default CompanyAboutPage
